function isLoggedIn () {
  // Aws Cognito/Porta auth
  return window.AwsAuth.currentSessionData
}

const isLoggedInAndRegistrationComplete = () => window.AwsAuth?.currentSessionData?.getIdToken()?.payload?.tc_consent === 'true'

function userData () {
  try {
    if (!isLoggedIn()) {
      return null
    } else {
      // Aws Cognito/Porta auth
      const {
        patient_id: id
      } = window.AwsAuth.currentSessionData

      return {
        id
      }
    }
  } catch (e) {
    return null
  }
}

export default {
  userData,
  isLoggedIn,
  isLoggedInAndRegistrationComplete
}
